import React from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'

const SuccessErrorPopup = ({
    show,
    handleClose,
    errorMessage,
    isSuccess
}) => {
    return (
        <>
            <Modal
                isOpen={show}
                toggle={handleClose}
                backdrop='static'
                keyboard={false}
                centered
                style={{ maxWidth: '360px' }}
            >
                <ModalHeader toggle={handleClose} className='modal-header_box blueBtn d-flex justify-content-between modal-header m-0' style={{ padding: '14px 18px' }}>
                    {isSuccess ? "Success" : "Error Message"}
                </ModalHeader>

                <ModalBody style={{ padding: '20px 22px 12px' }}>
                    <div className='text-center'>
                        <h3 className='text-warning mb-2' style={{ fontSize: '34px', lineHeight: 1 }}>
                            {!isSuccess ? (
                                <i className='fa fa-exclamation-circle'></i>
                            ) : (
                                <i className='fa fa-check-circle text-success'></i>
                            )}
                        </h3>
                        <h5 className='blue_dark_text font_weight_700 mb-0' style={{ fontSize: '16px', lineHeight: 1.4, overflowWrap: 'anywhere' }}>
                            {errorMessage}
                        </h5>
                    </div>
                </ModalBody>

                <div className='text-center' style={{ padding: '10px 16px 18px' }}>
                    <button
                        className='btn closeBtn'
                        onClick={handleClose}
                        style={{ minWidth: '58px', padding: '6px 14px' }}
                    >
                        OK
                    </button>
                </div>
            </Modal>
        </>
    )
}

export default SuccessErrorPopup
